module.exports = __webpack_public_path__ + "media/images/map-icons/google-satellite-c190764d0f055cc19770b685c9dac471.png";